export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.workbench.link': '歡迎使用',
  'pages.workbench.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  'pages.organizationAdmin.enterpriseOverview.title': '企業概覽',
  'pages.organizationAdmin.costCenter.accounts.title': '賬戶餘額',
  'pages.organizationAdmin.enterpriseSettings.adminPermissions.title':
    '管理員權限',
  'pages.organizationAdmin.enterpriseCulture.brandConfig.title': '品牌配置',
  'pages.organizationAdmin.common.initialized':
    '頁面已初始化，內容正在建設中。',
  'pages.organizationAdmin.aiUsage.usageOverview.title': 'AI 使用概覽',
  'pages.organizationAdmin.aiUsage.usageDetails.title': '用量詳情',
  'pages.organizationAdmin.aiUsage.usageLogs.title': '用量日誌',
  'pages.organizationAdmin.aiUsage.quotaManagement.title': '限額管理',
  'pages.organizationAdmin.aiUsage.storageSpace.capacityOverview.title':
    '容量概覽',
  'pages.organizationAdmin.aiUsage.storageSpace.limitManagement.title':
    '上限管理',
  'pages.organizationAdmin.aiUsage.storageSpace.storageCleanup.title':
    '存儲清理',
};
